"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromNFTRaw = exports.toNFTRaw = exports.toAccountRaw = exports.fromAccountRaw = exports.toAccountLikeRaw = exports.fromAccountLikeRaw = exports.toSubAccountRaw = exports.fromSubAccountRaw = exports.toChildAccountRaw = exports.fromChildAccountRaw = exports.toTokenAccountRaw = exports.fromTokenAccountRaw = exports.toSwapOperationRaw = exports.fromSwapOperationRaw = exports.fromOperationRaw = exports.inferSubOperations = exports.toOperationRaw = exports.fromBalanceHistoryRaw = exports.toBalanceHistoryRaw = void 0;
const bignumber_js_1 = require("bignumber.js");
const currencies_1 = require("../currencies");
const account_1 = __importDefault(require("../generated/account"));
const helpers_1 = require("./helpers");
const balanceHistoryCache_1 = require("@ledgerhq/coin-framework/account/balanceHistoryCache");
const index_1 = require("@ledgerhq/coin-framework/account/index");
const serialization_1 = require("@ledgerhq/coin-framework/account/serialization");
const bridge_1 = require("../bridge");
function toBalanceHistoryRaw(b) {
    return b.map(({ date, value }) => [date.toISOString(), value.toString()]);
}
exports.toBalanceHistoryRaw = toBalanceHistoryRaw;
function fromBalanceHistoryRaw(b) {
    return b.map(([date, value]) => ({
        date: new Date(date),
        value: parseFloat(value),
    }));
}
exports.fromBalanceHistoryRaw = fromBalanceHistoryRaw;
const toOperationRaw = (operation, preserveSubOperation) => {
    const copy = (0, serialization_1.toOperationRaw)(operation, preserveSubOperation);
    let e = copy.extra;
    if (e) {
        const family = (0, index_1.inferFamilyFromAccountId)(copy.accountId);
        if (family) {
            const abf = account_1.default[family];
            if (abf && abf.toOperationExtraRaw) {
                e = abf.toOperationExtraRaw(e);
            }
        }
    }
    return Object.assign(Object.assign({}, copy), { extra: e });
};
exports.toOperationRaw = toOperationRaw;
var serialization_2 = require("@ledgerhq/coin-framework/account/serialization");
Object.defineProperty(exports, "inferSubOperations", { enumerable: true, get: function () { return serialization_2.inferSubOperations; } });
const fromOperationRaw = (operation, accountId, subAccounts) => {
    const res = (0, serialization_1.fromOperationRaw)(operation, accountId, subAccounts);
    let e = res.extra;
    if (e) {
        const family = (0, index_1.inferFamilyFromAccountId)(res.accountId);
        if (family) {
            const abf = account_1.default[family];
            if (abf && abf.fromOperationExtraRaw) {
                e = abf.fromOperationExtraRaw(e);
            }
        }
    }
    return Object.assign(Object.assign({}, res), { extra: e || {} });
};
exports.fromOperationRaw = fromOperationRaw;
function fromSwapOperationRaw(raw) {
    const { fromAmount, toAmount } = raw;
    return Object.assign(Object.assign({}, raw), { fromAmount: new bignumber_js_1.BigNumber(fromAmount), toAmount: new bignumber_js_1.BigNumber(toAmount) });
}
exports.fromSwapOperationRaw = fromSwapOperationRaw;
function toSwapOperationRaw(so) {
    const { fromAmount, toAmount } = so;
    return Object.assign(Object.assign({}, so), { fromAmount: fromAmount.toString(), toAmount: toAmount.toString() });
}
exports.toSwapOperationRaw = toSwapOperationRaw;
function fromTokenAccountRaw(raw) {
    const { id, parentId, tokenId, starred, operations, pendingOperations, creationDate, balance, spendableBalance, balanceHistoryCache, swapHistory, approvals, } = raw;
    const token = (0, currencies_1.getTokenById)(tokenId);
    const convertOperation = op => (0, exports.fromOperationRaw)(op, id);
    const res = {
        type: "TokenAccount",
        id,
        parentId,
        token,
        starred: starred || false,
        balance: new bignumber_js_1.BigNumber(balance),
        spendableBalance: spendableBalance ? new bignumber_js_1.BigNumber(spendableBalance) : new bignumber_js_1.BigNumber(balance),
        creationDate: new Date(creationDate || Date.now()),
        operationsCount: raw.operationsCount || (operations && operations.length) || 0,
        operations: (operations || []).map(convertOperation),
        pendingOperations: (pendingOperations || []).map(convertOperation),
        swapHistory: (swapHistory || []).map(fromSwapOperationRaw),
        approvals,
        balanceHistoryCache: balanceHistoryCache || balanceHistoryCache_1.emptyHistoryCache,
    };
    res.balanceHistoryCache = (0, balanceHistoryCache_1.generateHistoryFromOperations)(res);
    return res;
}
exports.fromTokenAccountRaw = fromTokenAccountRaw;
function toTokenAccountRaw(ta) {
    const { id, parentId, token, starred, operations, operationsCount, pendingOperations, balance, spendableBalance, balanceHistoryCache, swapHistory, approvals, } = ta;
    return {
        type: "TokenAccountRaw",
        id,
        parentId,
        starred,
        tokenId: token.id,
        balance: balance.toString(),
        spendableBalance: spendableBalance.toString(),
        balanceHistoryCache,
        creationDate: ta.creationDate.toISOString(),
        operationsCount,
        operations: operations.map(o => (0, exports.toOperationRaw)(o)),
        pendingOperations: pendingOperations.map(o => (0, exports.toOperationRaw)(o)),
        swapHistory: (swapHistory || []).map(toSwapOperationRaw),
        approvals,
    };
}
exports.toTokenAccountRaw = toTokenAccountRaw;
function fromChildAccountRaw(raw) {
    const { id, name, parentId, currencyId, starred, creationDate, operations, operationsCount, pendingOperations, balance, address, balanceHistoryCache, swapHistory, } = raw;
    const currency = (0, currencies_1.getCryptoCurrencyById)(currencyId);
    const convertOperation = op => (0, exports.fromOperationRaw)(op, id);
    const res = {
        type: "ChildAccount",
        id,
        name,
        starred: starred || false,
        parentId,
        currency,
        address,
        balance: new bignumber_js_1.BigNumber(balance),
        creationDate: new Date(creationDate || Date.now()),
        operationsCount: operationsCount || (operations && operations.length) || 0,
        operations: (operations || []).map(convertOperation),
        pendingOperations: (pendingOperations || []).map(convertOperation),
        swapHistory: (swapHistory || []).map(fromSwapOperationRaw),
        balanceHistoryCache: balanceHistoryCache || balanceHistoryCache_1.emptyHistoryCache,
    };
    res.balanceHistoryCache = (0, balanceHistoryCache_1.generateHistoryFromOperations)(res);
    return res;
}
exports.fromChildAccountRaw = fromChildAccountRaw;
function toChildAccountRaw(ca) {
    const { id, name, parentId, starred, currency, operations, operationsCount, pendingOperations, balance, balanceHistoryCache, address, creationDate, swapHistory, } = ca;
    return {
        type: "ChildAccountRaw",
        id,
        name,
        starred,
        parentId,
        address,
        operationsCount,
        currencyId: currency.id,
        balance: balance.toString(),
        balanceHistoryCache,
        creationDate: creationDate.toISOString(),
        operations: operations.map(o => (0, exports.toOperationRaw)(o)),
        pendingOperations: pendingOperations.map(o => (0, exports.toOperationRaw)(o)),
        swapHistory: (swapHistory || []).map(toSwapOperationRaw),
    };
}
exports.toChildAccountRaw = toChildAccountRaw;
function fromSubAccountRaw(raw) {
    switch (raw.type) {
        case "ChildAccountRaw":
            return fromChildAccountRaw(raw);
        case "TokenAccountRaw":
            return fromTokenAccountRaw(raw);
        default:
            throw new Error("invalid raw.type=" + raw.type);
    }
}
exports.fromSubAccountRaw = fromSubAccountRaw;
function toSubAccountRaw(subAccount) {
    switch (subAccount.type) {
        case "ChildAccount":
            return toChildAccountRaw(subAccount);
        case "TokenAccount":
            return toTokenAccountRaw(subAccount);
        default:
            throw new Error("invalid subAccount.type=" + subAccount.type);
    }
}
exports.toSubAccountRaw = toSubAccountRaw;
function fromAccountLikeRaw(rawAccountLike) {
    if ("type" in rawAccountLike) {
        //$FlowFixMe
        return fromSubAccountRaw(rawAccountLike);
    }
    //$FlowFixMe
    return fromAccountRaw(rawAccountLike);
}
exports.fromAccountLikeRaw = fromAccountLikeRaw;
function toAccountLikeRaw(accountLike) {
    switch (accountLike.type) {
        case "Account":
            return toAccountRaw(accountLike);
        default:
            return toSubAccountRaw(accountLike);
    }
}
exports.toAccountLikeRaw = toAccountLikeRaw;
function fromAccountRaw(rawAccount) {
    const { id, seedIdentifier, derivationMode, index, xpub, starred, used, freshAddress, freshAddressPath, freshAddresses, name, blockHeight, endpointConfig, currencyId, feesCurrencyId, unitMagnitude, operations, operationsCount, pendingOperations, lastSyncDate, creationDate, balance, balanceHistoryCache, spendableBalance, subAccounts: subAccountsRaw, swapHistory, syncHash, nfts, } = rawAccount;
    const subAccounts = subAccountsRaw &&
        subAccountsRaw
            .map(ta => {
            if (ta.type === "TokenAccountRaw") {
                if ((0, currencies_1.findTokenById)(ta.tokenId)) {
                    return fromTokenAccountRaw(ta);
                }
            }
            else {
                return fromSubAccountRaw(ta);
            }
        })
            .filter(Boolean);
    const currency = (0, currencies_1.getCryptoCurrencyById)(currencyId);
    const feesCurrency = (feesCurrencyId && ((0, currencies_1.findCryptoCurrencyById)(feesCurrencyId) || (0, currencies_1.findTokenById)(feesCurrencyId))) ||
        undefined;
    const unit = currency.units.find(u => u.magnitude === unitMagnitude) || currency.units[0];
    const convertOperation = op => (0, exports.fromOperationRaw)(op, id, subAccounts);
    const res = {
        type: "Account",
        id,
        starred: starred || false,
        used: false,
        // filled again below
        seedIdentifier,
        derivationMode,
        index,
        freshAddress,
        freshAddressPath,
        freshAddresses: freshAddresses || [
            // in case user come from an old data that didn't support freshAddresses
            {
                derivationPath: freshAddressPath,
                address: freshAddress,
            },
        ],
        name,
        blockHeight,
        creationDate: new Date(creationDate || Date.now()),
        balance: new bignumber_js_1.BigNumber(balance),
        spendableBalance: new bignumber_js_1.BigNumber(spendableBalance || balance),
        operations: (operations || []).map(convertOperation),
        operationsCount: operationsCount || (operations && operations.length) || 0,
        pendingOperations: (pendingOperations || []).map(convertOperation),
        unit,
        currency,
        feesCurrency,
        lastSyncDate: new Date(lastSyncDate || 0),
        swapHistory: [],
        syncHash,
        balanceHistoryCache: balanceHistoryCache || balanceHistoryCache_1.emptyHistoryCache,
        nfts: nfts === null || nfts === void 0 ? void 0 : nfts.map(n => fromNFTRaw(n)),
    };
    res.balanceHistoryCache = (0, balanceHistoryCache_1.generateHistoryFromOperations)(res);
    if (typeof used === "undefined") {
        // old account data that didn't had the field yet
        res.used = !(0, helpers_1.isAccountEmpty)(res);
    }
    else {
        res.used = used;
    }
    if (xpub) {
        res.xpub = xpub;
    }
    if (endpointConfig) {
        res.endpointConfig = endpointConfig;
    }
    if (subAccounts) {
        res.subAccounts = subAccounts;
    }
    switch (res.currency.family) {
        default: {
            const bridge = (0, bridge_1.getAccountBridge)(res);
            const assignFromAccountRaw = bridge.assignFromAccountRaw;
            if (assignFromAccountRaw) {
                assignFromAccountRaw(rawAccount, res);
            }
        }
    }
    if (swapHistory) {
        res.swapHistory = swapHistory.map(fromSwapOperationRaw);
    }
    return res;
}
exports.fromAccountRaw = fromAccountRaw;
function toAccountRaw(account) {
    const { id, seedIdentifier, xpub, name, starred, used, derivationMode, index, freshAddress, freshAddressPath, freshAddresses, blockHeight, currency, feesCurrency, creationDate, operationsCount, operations, pendingOperations, unit, lastSyncDate, balance, balanceHistoryCache, spendableBalance, subAccounts, endpointConfig, swapHistory, syncHash, nfts, } = account;
    const res = {
        id,
        seedIdentifier,
        name,
        starred,
        used,
        derivationMode,
        index,
        freshAddress,
        freshAddressPath,
        freshAddresses,
        blockHeight,
        syncHash,
        creationDate: creationDate.toISOString(),
        operationsCount,
        operations: (operations || []).map(o => (0, exports.toOperationRaw)(o)),
        pendingOperations: (pendingOperations || []).map(o => (0, exports.toOperationRaw)(o)),
        currencyId: currency.id,
        unitMagnitude: unit.magnitude,
        lastSyncDate: lastSyncDate.toISOString(),
        balance: balance.toFixed(),
        spendableBalance: spendableBalance.toFixed(),
        nfts: nfts === null || nfts === void 0 ? void 0 : nfts.map(n => toNFTRaw(n)),
    };
    if (feesCurrency) {
        res.feesCurrencyId = feesCurrency.id;
    }
    if (balanceHistoryCache) {
        res.balanceHistoryCache = balanceHistoryCache;
    }
    if (endpointConfig) {
        res.endpointConfig = endpointConfig;
    }
    if (xpub) {
        res.xpub = xpub;
    }
    if (subAccounts) {
        res.subAccounts = subAccounts.map(toSubAccountRaw);
    }
    switch (account.currency.family) {
        default: {
            const bridge = (0, bridge_1.getAccountBridge)(account);
            const assignToAccountRaw = bridge.assignToAccountRaw;
            if (assignToAccountRaw) {
                assignToAccountRaw(account, res);
            }
        }
    }
    if (swapHistory) {
        res.swapHistory = swapHistory.map(toSwapOperationRaw);
    }
    return res;
}
exports.toAccountRaw = toAccountRaw;
function toNFTRaw({ id, tokenId, amount, contract, standard, currencyId, metadata, }) {
    return {
        id,
        tokenId,
        amount: amount.toFixed(),
        contract,
        standard,
        currencyId,
        metadata,
    };
}
exports.toNFTRaw = toNFTRaw;
function fromNFTRaw({ id, tokenId, amount, contract, standard, currencyId, metadata, }) {
    return {
        id,
        tokenId,
        amount: new bignumber_js_1.BigNumber(amount),
        contract,
        standard,
        currencyId,
        metadata,
    };
}
exports.fromNFTRaw = fromNFTRaw;
//# sourceMappingURL=serialization.js.map